import { BannerType, BLANK } from '../../consts';
export const getAnchorProps = (banner) => {
    const { game, redirection, type } = banner;
    let href;
    let target;
    let altText;
    if (type === BannerType.REDIRECTION && redirection) {
        if (redirection.target === BLANK) {
            ({ url: href } = redirection);
        }
        // TODO: we should reconsider having altText field in contentstack,
        //  it could potentially confuse publishers as we are having title field
        ({ target, altText } = redirection);
    }
    else if (type === BannerType.GAME && game) {
        href = game.launchUrl;
        target = BLANK;
    }
    return { href, target, altText };
};
